const data = {
  tlapan: {
    nombre: "Tlalpan 1 | Benito Juárez",
    direccion:
      "Calz. de Tlalpan No. 965, Col. Niños Héroes de Chapultepec, C.P. 03440, Del. Benito Juárez, CDMX, México",
    horario:
      "Lunes a Viernes 10:00 am a 7:00 pm, Sábados y Domingos 11:00 am a 6:00 pm",
    contacto: "(55) 3330 0131 / (55) 3330 0132 / ana.moran@mundoin.mx",
    imgs: [
      "https://cdn.shopify.com/s/files/1/1233/2374/files/TLALPAN_1_IZQUIERDO.jpg?v=1722221243",
      "https://cdn.shopify.com/s/files/1/1233/2374/files/TLALPAN_1_CENTRO.jpg?v=1722221244",
      "https://cdn.shopify.com/s/files/1/1233/2374/files/TLALPAN_1_DERECHO.jpg?v=1722221244",
    ],
    recorrido: "https://my.matterport.com/show/?m=YQoUqzdvJ7u",
    map: '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3763.631171154194!2d-99.14229182480535!3d19.385116542195604!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d1fe4b9a878a75%3A0xd653b0e7c93cdcf8!2sMundo%20In%20-%20Tlalpan%201!5e0!3m2!1sen!2smx!4v1721063068623!5m2!1sen!2smx" width="100%" height="250" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>',
  },
  tlapan2: {
    nombre: "Tlalpan 2 | Coyoacán",
    direccion:
      "Calz. de Tlalpan No. 2786, Col. Emiliano Zapata, C.P. 04810, Alc. Coyoacán, CDMX",
    horario:
      "Lunes a Viernes 10:00 am a 7:00 pm, Sábados y Domingos 11:00 am a 6:00 pm",
    contacto: "55 5544 6684 ariana.sanchez@mundoin.mx",
    imgs: [
      "https://cdn.shopify.com/s/files/1/1233/2374/files/TLALPAN2_IZQUIERDO.jpg?v=1722221391",
      "https://cdn.shopify.com/s/files/1/1233/2374/files/TLALPAN2_CENTRO.jpg?v=1722221392",
      "https://cdn.shopify.com/s/files/1/1233/2374/files/TLALPAN2_DERECHO.jpg?v=1722221392",
    ],
    recorrido: "",
    map: '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3764.9643777217793!2d-99.1389396!3d19.327351999999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85ce01c92e003163%3A0xf5d7cd616a7494a0!2sMundo%20In%20Tlalpan%202!5e0!3m2!1ses-419!2smx!4v1721320656973!5m2!1ses-419!2smx" width="100%" height="250" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>',
  },
  vallejo: {
    nombre: "Vallejo",
    direccion:
      "Calz. Vallejo No. 306, Col. San Francisco Xocotitla, C.P. 02960, Alc. Azcapotzalco, CDMX",
    horario: "Lunes a Viernes 10:00 am a 7:00 pm, Sábado y Domingo de 11:00 am a 6:00 pm",
    contacto: "55 5556 3905 / 555556 4841 / said.lopez@mundoin.mx.  Whatsapp: 5525127038",
    imgs: [
      "https://cdn.shopify.com/s/files/1/1233/2374/files/VALLEJO_IZQUIERDO.jpg?v=1722221534",
      "https://cdn.shopify.com/s/files/1/1233/2374/files/VALLEJO_CENTRO.jpg?v=1722221534",
      "https://cdn.shopify.com/s/files/1/1233/2374/files/VALLEJO_DERECHO.jpg?v=1722221534",
    ],
    recorrido: "",
    map: '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3761.6917730809014!2d-99.1446431!3d19.4688516!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d1f902b6f62dbf%3A0xa6b3123f9e1028cc!2sMundo%20In%20-%20Vallejo!5e0!3m2!1ses-419!2smx!4v1721320842687!5m2!1ses-419!2smx" width="100%" height="250" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>',
  },
  toluca: {
    nombre: "Toluca",
    direccion:
      "Carretera Toluca-México No. 5 Km 48.5, Municipio de Ocoyoacac. Toluca, 52740, Estado de México",
    horario:
      "Lunes a Viernes 10:00 am a 7:00 pm y Sábados y domingos 11:00 am a 6:00 pm",
    contacto: "(728) 2845391 / (728) 2878628 / eder.quiles@mundoin.mx",
    imgs: [
      "https://cdn.shopify.com/s/files/1/1233/2374/files/TOLUCA_IZQUIERDO.jpg?v=1722225534",
      "https://cdn.shopify.com/s/files/1/1233/2374/files/TOLUCA_CENTRO.jpg?v=1722225534",
      "https://cdn.shopify.com/s/files/1/1233/2374/files/TOLUCA_DERECHO.jpg?v=1722225534",
    ],
    recorrido: "",
    map: '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3766.0363819021804!2d-99.4958527!3d19.280784000000004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85cdf5a9385d9cd3%3A0x2fd8f910025ccc7!2sMundo%20In%20-%20Toluca!5e0!3m2!1ses-419!2smx!4v1721320951543!5m2!1ses-419!2smx" width="100%" height="250" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>',
  },
  centro: {
    nombre: "Centro",
    direccion:
      "Belisario Domínguez No. 31, Col. Centro Histórico, C.P. 06010, Del. Cuauhtémoc, CDMX, México",
    horario: "Lunes a Viernes 10:00 am a 7:00 pm y Sábados 10:00 am a 4:00 pm",
    contacto: "5555211594 / 5541844727 sergio.gutierrez@mundoin.mx",
    imgs: [
      "https://cdn.shopify.com/s/files/1/1233/2374/files/CENTRO_IZQUIERDO.jpg?v=1722225863",
      "https://cdn.shopify.com/s/files/1/1233/2374/files/CENTRO_CENTRO.jpg?v=1722225863",
      "https://cdn.shopify.com/s/files/1/1233/2374/files/CENTRO_DERECHO.jpg?v=1722225863",
    ],
    recorrido: "https://my.matterport.com/show/?m=2D4nngbkQWr",
    map: '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3762.4043310668712!2d-99.14015932480427!3d19.438126640504393!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d1f92dec584017%3A0xdae1762f7f921882!2sWorld%20In%20-%20Center!5e0!3m2!1sen!2smx!4v1721063346552!5m2!1sen!2smx" width="100%" height="250" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>',
  },
  naucalpan: {
    nombre: "Naucalpan",
    direccion:
      "Perif. Blvd. Manuel Ávila Camacho 460-local B San Andres Atoto, 53500 Naucalpan de Juárez, México 53500",
    horario:
      "Lunes a Viernes 10:00 am a 7:00 pm, Sábados y Domingos 11:00 am a 6:00 pm",
    contacto: "55 5929 0880 / jose.ramon@mundoin.mx",
    imgs: [
      "https://cdn.shopify.com/s/files/1/1233/2374/files/NAUCALPAN_IZQUIERDO.jpg?v=1722226793",
      "https://cdn.shopify.com/s/files/1/1233/2374/files/NAUCALPAN_CENTRO.jpg?v=1722226793",
      "https://cdn.shopify.com/s/files/1/1233/2374/files/NAUCALPAN_DERECHO.jpg?v=1722226793",
    ],
    recorrido: "",
    map: '<iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15046.934793855224!2d-99.2258871!3d19.4670451!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d203f83fb75899%3A0x66393544b489e062!2sMundo%20In%20Naucalpan!5e0!3m2!1sen!2smx!4v1721084655801!5m2!1sen!2smx" width="100%" height="250" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>',
  },
  gustavo: {
    nombre: "Gustavo Baz",
    direccion:
      "Av. Gustavo Baz 401 Local 4, Fracc. Industrial Tlaxcolpan, Tlalnepantla, Edo. De México",
    horario:
      "Lunes a Viernes 10:00 am a 07:00 pm - Sábados y Domingos 11:00 am a 06:00 pm",
    contacto:
      "5593401124 / 5593401125/ 5643923949 / daniel.martinez@mundoin.mx",
    imgs: [
      "https://cdn.shopify.com/s/files/1/1233/2374/files/GUSTAVO_IZQUIERDO.jpg?v=1722226938",
      "https://cdn.shopify.com/s/files/1/1233/2374/files/GUSTAVO_CENTRO.jpg?v=1722226938",
      "https://cdn.shopify.com/s/files/1/1233/2374/files/GUSTAVO_DERECHO.jpg?v=1722226938",
    ],
    recorrido: "",
    map: '<iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15039.365002830253!2d-99.2063566!3d19.5484279!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d21dd703178dcf%3A0x35fff915270cc970!2sMundo%20In%20-%20Gustavo%20Baz!5e0!3m2!1sen!2smx!4v1721084846145!5m2!1sen!2smx" width="100%" height="250" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>',
  },
  puebla: {
    nombre: "Puebla",
    direccion: "Cto. Juan Pablo II 3303, Animas Puebla, Puebla 72400",
    horario:
      "Lunes a Viernes 11:00 a 20:00 hrs. Sábado a Domingo 11:00 a 18:00 hrs.",
    contacto: "222 963 9839 / 222 963 9840 / francisco.castillo@mundoin.mx",
    imgs: [
      "https://cdn.shopify.com/s/files/1/1233/2374/files/PUEBLA_IZQUIERDO.jpg?v=1722227037",
      "https://cdn.shopify.com/s/files/1/1233/2374/files/PUEBLA_CENTRO.jpg?v=1722227037",
      "https://cdn.shopify.com/s/files/1/1233/2374/files/PUEBLA_DERECHO.jpg?v=1722227037",
    ],
    recorrido: "",
    map: '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3771.494188147948!2d-98.2318296!3d19.0419977!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85cfc7fb539e2c37%3A0xdfe60e0ed5619f4!2sMundo%20In%20-%20Puebla!5e0!3m2!1sen!2smx!4v1721085240336!5m2!1sen!2smx" width="100%" height="250" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>',
  },
  queretaro: {
    nombre: "Querétaro",
    direccion:
      "Blvd. Bernardo Quintana No. 48, Col. Álamos 1era Sección. Santiago de Querétaro, Querétaro 76160",
    horario:
      "Lunes a Viernes 10:00 am a 7:00 pm y Sábados y domingos 11:00 am a 6:00 pm",
    contacto: "(442) 2238299 / (442) 2238268 / azucena.gonzalez@mundoin.mx",
    imgs: [
      "https://cdn.shopify.com/s/files/1/1233/2374/files/QRO_IZQUIERDO.jpg?v=1722227177",
      "https://cdn.shopify.com/s/files/1/1233/2374/files/QRO_CENTRO.jpg?v=1722227176",
      "https://cdn.shopify.com/s/files/1/1233/2374/files/QRO_DERECHA.jpg?v=1722227177",
    ],
    recorrido: "https://my.matterport.com/show/?m=Ni9S9Jq9ott",
    map: '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3734.668233110535!2d-100.37573979999999!3d20.601602!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d35b3762191223%3A0x9d6321d24b463edb!2sMundo%20In%20-%20Quer%C3%A9taro!5e0!3m2!1sen!2smx!4v1721085403311!5m2!1sen!2smx" width="100%" height="250" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>',
  },
};

function onSelect(ev) {
  const container = document.getElementById("info-sucursal-container");
  const tourContainer = document.getElementById("tour-container");
  const tourLink = document.getElementById("tour-link");
  container.classList.remove("twl-hidden");
  const l1 = document.getElementById("label-1");
  const l2 = document.getElementById("label-2");
  const l3 = document.getElementById("label-3");
  const name = document.getElementById("name-sucursal");
  const direccion = document.getElementById("sucursal-direccion");
  const horario = document.getElementById("sucursal-horario");
  const contacto = document.getElementById("sucursal-contacto");
  const map = document.getElementById("sucursal-map");
  const shop = data[ev.id];
  name.innerText = `Sucursal ${shop.nombre}`;
  direccion.innerText = shop.direccion;
  contacto.innerText = shop.contacto;
  horario.innerText = shop.horario;
  map.innerHTML = shop.map;
  l1.style = `--_img: url(${shop.imgs[0]})`;
  l2.style = `--_img: url(${shop.imgs[1]})`;
  l3.style = `--_img: url(${shop.imgs[2]})`;
  if (shop.recorrido) {
    tourContainer.style.display = "flex";
    tourLink.href = shop.recorrido;
  } else {
    tourContainer.style.display = "none";
    tourLink.href = "#";
  }
}

function onScrollX(ev) {
  const sucursalesContainer = document.getElementById("sucursales-container");
  const positionX = sucursalesContainer.scrollLeft;
  if (ev.id === "r") {
    sucursalesContainer.scrollLeft += 300;
  } else {
    positionX === 0
      ? (sucursalesContainer.scrollLeft = 2200)
      : (sucursalesContainer.scrollLeft -= 300);
  }
}
